import React, { useState, useEffect } from 'react';
import Home from "./Home";
import About from "./About";
import Resume from "./Resume";
import Projects from "./Projects";
import Contact from "./Contact";
import "../App.css";

export default function Display() {
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setSidebarVisible(window.innerWidth > 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
//comment
  return (
    <div 
      className={`transition-all duration-300 ease-in-out w-screen back text-white ${
        sidebarVisible ? 'pl-[25%]' : 'pl-0'
      }`}
    >
      <Home />
      <About />
      <Resume />
      <Projects />
      <Contact />
    </div>
  );
}